import React, {Component} from 'react';
import {Modal, ModalBody, ModalHeader} from 'reactstrap';
import {FaIcon} from "../FaIcon";
import {BusinessUnitLabelsManager} from "../business_units/BusinessUnitLabelsManager";
import { withTranslation } from 'react-i18next';

class AssignBusinessUnitLabelsModalComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            urlsInfo: null,
        };
    }

    renderModalHeader() {
        const { t } = this.props;
        return (
            <ModalHeader>
                <FaIcon iconName="tags"/>
                {t('dashboard.labels_modal_title')} <span>{this.props.businessUnitName}</span>
            </ModalHeader>
        )
    }

    render() {
        return (
            <Modal isOpen={this.props.isOpen} toggle={this.props.toggle}>
                <form>
                    {this.renderModalHeader()}
                    <ModalBody>
                        <div className="modal-section">
                            <BusinessUnitLabelsManager initialLabels={this.props.businessUnitLabels}
                                                       businessUnitId={this.props.businessUnitId}
                                                       onLabelsChange={this.props.onLabelsChange}
                            />
                        </div>
                    </ModalBody>
                </form>
            </Modal>
        );
    }
}

export const AssignBusinessUnitLabelsModal = withTranslation()(AssignBusinessUnitLabelsModalComponent);
